import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { trackSubscriptionCompleted } from '../../utils/analytics';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();

  useEffect(() => {
    trackSubscriptionCompleted();
    if (refreshProfile) refreshProfile();
    navigate('/settings/subscription?checkout=success', { replace: true });
  }, []);

  return null;
}
